import { Component, OnInit } from '@angular/core';
import { ModalExtended} from 'ngx-dynamic-modal';

@Component({
  selector: 'app-element-log-view-modal',
  templateUrl: './element-log-view-modal.component.html',
  styleUrls: ['./element-log-view-modal.component.scss']
})
export class ElementLogViewModalComponent extends ModalExtended implements OnInit {
   data: any;
   view: string;
   element: object;
  constructor() {
    super();
  }

  ngOnInit() {
      this.view = this.data.data.action;
      this.element = this.data.data.data;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/modals/element-log--view-modal/element-log-view-modal.component.ts